import Swiper from 'swiper';

import 'swiper/css/pagination';
import 'swiper/css';
import { Navigation, Pagination } from 'swiper/modules';

const sections = document.querySelectorAll('section.header-slider');

let nextCursor, nextCursorIcon;

if (sections.length > 0) {
	nextCursor = document.createElement('div');
	nextCursorIcon = document.createElement('i');
	nextCursorIcon.setAttribute('class', 'far fa-arrow-right pointer-events-none');
	nextCursor.setAttribute('class', 'active top-0 left-0 max-lg:hidden -translate-1/2 cursor-none pointer-events-none fixed mr-(--gap-auto) right-outer-column-width size-24 grid place-items-center border-1 border-white backdrop-blur-sm bg-white/0 text-white rounded-full z-1 not-active:scale-0 duration-500 transition-transform');
	nextCursor.appendChild(nextCursorIcon);
	document.body.appendChild(nextCursor);

	document.addEventListener('mousemove', (e) => {
		nextCursor.style.left = e.clientX + 'px';
		nextCursor.style.top = e.clientY + 'px';
	});
}

function cursorShow() {
	nextCursor.classList.add('active');
}

function cursorHide() {
	nextCursor.classList.remove('active');
}


sections.forEach(section => {
	const swiperEl = section.querySelector('.swiper');
	const slides = swiperEl?.querySelectorAll('.swiper-slide');
	const prevElMobile = section.querySelector('.swiper-button-mobile.swiper-button-prev');
	const nextElMobile = section.querySelector('.swiper-button-mobile.swiper-button-next');

	document.addEventListener('mousemove', (e) => {
		if (e.target.closest('.swiper-slide') && !e.target.closest('.swiper-slide-active')) {
			cursorShow();
		} else {
			cursorHide();
		}
	});

	if (swiperEl) {
		const swiper = new Swiper(swiperEl, {
			modules: [Navigation, Pagination],
			direction: 'horizontal',
			spaceBetween: 8,
			loop: true,
			slidesPerView: 1.2,
			pagination: {
				enabled: true,
				renderCustom: function (_swiper, current, total) {
					const wrapper = document.createElement('div');
					wrapper.setAttribute('class', 'flex max-lg:w-full gap-[7px] max-lg:[&>*]:flex-1');

					for (let i = 0; i < total; i++) {
						const bullet = document.createElement('div');
						bullet.setAttribute('class', 'h-0.5 lg:w-16 bg-neutral-20 active:bg-black');

						if (i === current - 1) {
							bullet.classList.add('active');
						}

						wrapper.appendChild(bullet);
					}

					return wrapper.outerHTML;
				},
				el: '.swiper-pagination',
				type: 'custom',
			},
			navigation: {
				prevEl: prevElMobile,
				nextEl: nextElMobile,
			},
			breakpoints: {
				640: { slidesPerView: 1.2 },
				820: { slidesPerView: 1.5 },
				1024: { slidesPerView: 1.7 },
				1600: { slidesPerView: 2.2 },
			}
		});

		slides.forEach(slide => {
			slide.addEventListener('click', (e) => {
				if (!slide.classList.contains('swiper-slide-active')) {
					e.preventDefault();
					swiper.slideNext();
				}
			});
		});
	}
});
